<script>
import {
  ArrowUpIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
} from "vue-feather-icons";
import { Carousel, Slide } from "vue-carousel";

import Navbar from "@/view/front/components/navbar";
import Multiselect from "vue-multiselect";
import Footer from "@/view/front/components/footer";
import Course from "@/view/front/components/course";
import IndexService from "@/MainServices/IndexService.js";
import Skeleton from "@/view/front/components/skeleton_home";
import skeleton_Programs from "@/view/front/components/skeleton_Programs";
import skeleton_disciplines from "@/view/front/components/skeleton_disciplines";
import API from "@/core/api";
/**
 * Index-course component
 */
export default {
  data() {
    return {
      slide: 0,
      listings: [],
      disciplines: [],
      featured_institues: [],
      cities: [],
      selected_cities: [],
      api: API.API_HOME,
      loading: true,
      searchInput: "",
    };
  },
  methods: {
    onImageLoadFailure(event) {
      event.target.src = "/images/uni_demo_profile.png";
    },
    searchFilter() {
      this.$session.set("searchInput", this.searchInput);
      this.$session.set("selected_cities", this.selected_cities);
      this.$router.push({ name: 'searchCourses' })
    },
    uniByCity(city) {
      this.$session.set("searchUniByCity", city);
      this.$router.push({ name: 'UniversitiesWithListings' })
    }
  },
  components: {
    Multiselect,
    Navbar,
    Footer,
    Course,
    Skeleton,
    skeleton_Programs,
    skeleton_disciplines,
    ArrowUpIcon,
  },
  mounted() {
    IndexService.getBasicData()
      .then((res) => {
        this.listings = res.data.listings;
        this.disciplines = res.data.disciplines;
        this.featured_institues = res.data.featured_institues;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

      IndexService.getCities()
      .then((res) => {
        res.data.map((el) => {
          this.cities.push({
            id: el.id,
            value: el.city,
          });
        });
      })
      .catch((e) => {});
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<template>
  <div>
    <Navbar :nav-light="true" />

    <!-- Hero Start -->
    <section>
      
      <div style="background: url('images/myuni/homepage/PNG/homepage_top_bg.png')" class="jumbotron bg-cover text-white mt-5rem mb-0 home-p-top-div-im">
          <div class="container py-5 text-center">
              <h5 class="text-success letter-spacing-2px font-weight-bold">Lifelong learning resources</h5>
              <h3 class="mb-0 display-3 font-weight-900">Vocational Training & <br> Academic Courses <br> Across Pakistan</h3>
              <form class="form-inline mt-5" action="/action_page.php">
                <div class="mx-auto w-100 flex-show">
                  <input type="text" v-model="searchInput" v-on:keyup.enter="searchFilter" class="form-control mb-2 mr-sm-2 header-input" id="course" placeholder="Search course" name="cpurse">
                    <multiselect
                    class="slect_home_hero"
                      id="multiselectCities"
                      v-model="selected_cities"
                      :height="300"
                      :options="cities"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      v-on:keyup.enter="searchFilter"
                      placeholder="Select Cities"
                      label="value"
                      track-by="value"
                      :preselect-first="false"
                    >
                    </multiselect>
                  <button type="button" @click="searchFilter" class="btn btn-success mb-2 header-submit-btn font-weight-bold">Search</button>
                </div>
              </form>
              
          </div>
      </div>

      <div class="position-relative">
        <div class="shape overflow-hidden text-white">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>

      <div class="p-3" style="background-color: rgb(46 202 139 / 69%);">
        <b-carousel fade id="carousel-1" v-model="slide" class="slides">
          <b-carousel-slide>
            <div class="container text-dark latest-news-text-fnt-s">
              <strong>Latest News: </strong>
              <span class="mx-auto">
                Last day to apply for the (university name) in (course name) is Nov 31, 2022. 
                Please be sure to read all requirements before the due.
              </span>
            </div>
          </b-carousel-slide>
          <b-carousel-slide>
            <div class="container text-dark latest-news-text-fnt-s">
              <strong>Latest News: </strong>
              <span class="mx-auto">
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore
              </span>
            </div>
          </b-carousel-slide>
        </b-carousel>
      </div>

        
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!-- Popular Desciplines START -->
    <section class="my-4rem">
      <div class="container p-5 text-center">
        <h2 class="text-primary font-weight-bold mb-5 r-font-s-23">View all popular disciplines</h2>
        <skeleton_disciplines v-if="loading" /> 
        <div class="flex-show">
          <div v-for="(discipline, index) in disciplines"
            :key="index" class="">
            <router-link
              :to="{
                name: 'DisciplineCourses',
                params: { discipline_name: discipline.slug.toLowerCase().trim(),id: discipline.id },
              }"
              class="name body-discipline-text"
            >
              {{ discipline.discipline }}
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!--end section-->
    <!-- Popular Desciplines END -->

    <!-- Features Start -->
    <section class="bg-white mt-5">
      <div class="container p-5">
        <div class="text-center">
          <h2 class="text-primary font-weight-bold f-p-m-tb r-font-s-23">Featured Programs</h2>
        </div>

        <skeleton_Programs v-if="loading" /> 
        <div class="row pb-3">
          <div class="col-2" v-for="(singleCourse, index) in listings" :key="index">
            <Course :course="singleCourse" v-if="index < 6"/>
          </div>
        </div>
      </div>
      <!--end container-->

      <div class="text-center hi-m-view-all-btn-div">
        <router-link :to="{ name: 'searchCourses' }" class="btn btn-success hi-m-view-all-btn"
              >View all <i class="mdi mdi-chevron-right"></i>
              </router-link>
        </div>
    </section>
    <!--end section-->
    <!-- Features End -->

    <!-- Cta Start -->
    <section
      class="section bg-cta"
      style="background: url('images/myuni/homepage/PNG/Video_.png');"
      id="cta" 
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title">
              <a
                href="javascript: void(0);"
                v-b-modal.modal-1
                class="play-btn mb-5 video-play-icon"
              >
                <!-- <play-icon class="fea icon-ex-md text-white title-dark"></play-icon> -->

                <img src="images/myuni/homepage/SVG/video_play.svg" >
              </a>
              <h4 class="title title-dark text-white mb-4">
                We bring new online opportunities
              </h4>
              <p class="text-light para-desc para-dark mx-auto" style="font-size: 16px;">
                Start working with myUni that can provide everything you need <br>
                  to connect, find and study for higher studies
              </p>
              
              <b-modal
                id="modal-1"
                hide-footer
                size="lg"
                header-close-variant="white"
                header-class="border-0"
                content-class="border-0"
                centered
              >
                <vimeo-player
                  ref="player"
                  :player-width="750"
                  :player-height="450"
                  :video-id="12022651"
                />
              </b-modal>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Cta End -->

    <!-- Course list Start -->
    <section class="section pb-0">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 mb-def-all border-10px" style="background-color: #D3E6FC;">
            <div class="text-center">
              <h4 class="text-primary mb-0 mt-5 font-weight-bold r-font-s-23">Featured universities</h4>
              <p class="r-font-s-16px">Select your favourite <span class="text-primary">University</span> and apply in your dream course.</p>
              <Skeleton v-if="loading" /> 
              <div class="flex-show mt-3 mb-2">
                <div v-for="(university, index) in featured_institues" :key="index">
                  <!-- start card -->
                  <div v-if="index < 8" class="mb-2">
                    <div class="card p-3 mr-2 r--hi-card-img-top-div">
                      <!-- :src="api + `${university.image_path}`"   -->
                      <img class="card-img-top w-75 mx-auto"
                      @error="onImageLoadFailure($event)"
                      :src="api + `${university.image_path}` || ''"
                      alt="graduate icon">
                      <div class="">
                        <h5 class="my-2 f-uni-name">{{ university.name }}</h5>
                      </div>
                    </div>

                    <div>
                      <router-link
                          :to="{
                            name: 'UniCourses',
                            params: { uni_name: university.user_slug.toLowerCase().trim(), uni_id: university.id},
                          }"
                          class="btn btn-sm btn-outline-primary f-u-view-course-btn"
                          style=""
                          >View Courses</router-link
                        >
                    </div>
                  </div>
                
                <!--end card-->
                </div>
              </div>

              <div class="mb-5">
                <router-link
                
                    :to="{ name: 'UniversitiesWithListings' }"
                    class="btn btn-success px-5 font-weight-bold"
                    >View all universties <i class="mdi mdi-chevron-right"></i>
                    </router-link>
              </div>
              
            </div>
          </div>
          <div class="col-lg-6 bg-light mb-def-all border-10px">
            <div class="text-center">
              <h4 class="text-primary mb-0 mt-5 font-weight-bold r-font-s-23">Find universities by cities</h4>
              <div class="flex-show mt-3 mb-2">
                <img src="/images/myuni/homepage/PNG/Faisalabad.png" role="button" alt="Faisalabad" class="m-1" @click="uniByCity('Faisalabad')">
                <img src="/images/myuni/homepage/PNG/Gujranwala.png" role="button" alt="Gujranwala" class="m-1" @click="uniByCity('Gujranwala')">
                <img src="/images/myuni/homepage/PNG/Islamabad.png" role="button" alt="Islamabad" class="m-1" @click="uniByCity('Islamabad')">
                <img src="/images/myuni/homepage/PNG/Karachi.png" role="button" alt="Karachi" class="m-1" @click="uniByCity('Karachi')">
                <img src="/images/myuni/homepage/PNG/Lahore.png" role="button" alt="Lahore" class="m-1" @click="uniByCity('Lahore')">
                <img src="/images/myuni/homepage/PNG/Peshawar.png" role="button" alt="Peshawar" class="m-1" @click="uniByCity('Peshawar')">
                <img src="/images/myuni/homepage/PNG/Quetta.png" role="button" alt="Quetta" class="m-1" @click="uniByCity('Quetta')">
                <img src="/images/myuni/homepage/PNG/Sialkot.png" role="button" alt="Sialkot" class="m-1" @click="uniByCity('Sialkot')">
                <img src="/images/myuni/homepage/PNG/Lahore.png" role="button" alt="Lahore" class="m-1" @click="uniByCity('Lahore')">
                <img src="/images/myuni/homepage/PNG/Peshawar.png" role="button" alt="Peshawar" class="m-1" @click="uniByCity('Peshawar')">
                <img src="/images/myuni/homepage/PNG/Quetta.png" role="button" alt="Quetta" class="m-1" @click="uniByCity('Quetta')">
                <img src="/images/myuni/homepage/PNG/Sialkot.png" role="button" alt="Sialkot" class="m-1" @click="uniByCity('Sialkot')">
                
              </div>

              <div class="mb-5">
                <router-link
                    :to="{ name: 'allcities' }"
                    class="btn btn-success px-5 font-weight-bold"
                    >View all <i class="mdi mdi-chevron-right"></i>
                    </router-link>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Course list End -->

    <Footer />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style scoped>
  ::v-deep .carousel-caption {
    display: contents;
  }

  ::v-deep .modal-content {
    background-color: transparent;
  }
  .text-primary{
    color: #185AA5 !important;
  }
  .font-weight-bold {
    font-weight: bold !important;
  }
  .px-5 {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
  .multiselect__tags {
    border-radius: 2rem !important;
  }
  .text-success {
    color: #90e0c2 !important;
  }
</style>
